module.exports = __webpack_public_path__ + "img/489B7A_A0E7D9_6DC5AC_87DAC7-256px.838eb485.png";